import React from "react";
import './main.css'
function Main() {
  return (
    <div className="fk-iframe-wrapper">
      <iframe
        src="https://flipkartconnectjuryawards.com/"
        title="Flipkart Connect Jury Awards"
        className="fk-full-iframe"
        loading="lazy"
        allowFullScreen
      />
    </div>
  );
}

export default Main;